import React, { useState, useEffect, useCallback, useRef } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { selectors } from "@Src/redux/reducers";
import { defaultLocale } from "./i18nUtil";
import { translate } from "./translate";

const TranslateAsync = ({ text, displayHTML = false }) => {
  const language = useSelector(selectors.getLanguageSelector);
  const [translatedText, setTranslatedText] = useState(null);
  const mountedRef = useRef(true);

  const translateText = useCallback(() => {
    if (!text) return;

    mountedRef.current = true;

    if (language === defaultLocale) {
      if (mountedRef.current) {
        setTranslatedText(text);
      }
    } else {
      translate(text, language, (res) => {
        if (mountedRef.current) setTranslatedText(res);
      });
    }
  }, [language, text]);

  useEffect(() => {
    translateText();
    return () => {
      // this allieviates a "state change on unmounted component" error
      mountedRef.current = false;
    };
  }, [text, translateText, mountedRef]);

  if (!translatedText) return null;
  if (displayHTML) {
    return <span dangerouslySetInnerHTML={{ __html: translatedText }} />;
  }
  return translatedText;
};

TranslateAsync.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  displayHTML: PropTypes.bool,
};

export default TranslateAsync;
